const getTranslatedPath = (path, lang) => {

  const pathSegments = path.split("/").filter(Boolean);
  console.log(pathSegments);
  if (lang === "ua") {
    pathSegments.shift();
    return `/${pathSegments.join("/")}`;
  } else {
    const newPath = `/${lang}${
      pathSegments.length === 0 ? "" : `/${pathSegments.join("/")}`
    }`;
    return newPath.replace(/\/(en|ua)(?=\/\1)/, '');
  }
};

export default getTranslatedPath;
